import React from 'react'

function DashboardOperacional(props) {
  return <div>Operacional</div>
}

export default DashboardOperacional
